






exports.default =
  props:
    offset:
      default: 300
  data: ->
    visible: false

  methods:
    onScroll: ->
      if @window.scrollTop() > @offset
        @visible = true
      else
        @visible = false

    goToTop: ->
      jQuery('html, body').animate({scrollTop: 0}, 500);

  mounted: ->
    @window = jQuery(window)
    @window.scroll(@onScroll)
    @onScroll()



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/go_to_top.vue